export default __webpack_public_path__ + "static/media/p01 p01.8f730380.jpg";